import {HTTP} from "@/helpers/http-common"
const urlModule = 'parametros'

const get = (parametros) =>new Promise((resolve,reject)=>{
  const {clave} = parametros;
  HTTP.get(
    `/api/${urlModule}/${clave}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const update = (parametros) =>new Promise((resolve,reject)=>{
  const {clave 
    , horarioConversionInicio
    , horarioConversionFin
    , horarioDescargaInicio
    , horarioDescargaFin
    , dias
    , summiterID
    , urlBuzonSFTP
    , usuarioBuzonSFTP
    , passwordBuzonSFTP
    , puertoBuzonSFTP
    , seguridadHabilitadaZIP
    , passwordZIP
    , numeroIntentos
  } = parametros;
  HTTP
  .put(
    `/api/${urlModule}`
    , {clave 
      , horarioConversionInicio
      , horarioConversionFin
      , horarioDescargaInicio
      , horarioDescargaFin, status:true
      , dias
      , summiterID
      , urlBuzonSFTP
      , usuarioBuzonSFTP
      , passwordBuzonSFTP
      , puertoBuzonSFTP
      , seguridadHabilitadaZIP
      , passwordZIP
      , numeroIntentos
    }
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

//Export methods
export default {
  get  
  , update
}





// WEBPACK FOOTER //
// ./src/services/generales/parametros/index.js